//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './RepairsOrderClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetInvoiceAddressRepairsOrderQueryParameters = {
  contactId?: string | undefined ;
}



export type RequestDeviceRepairsOrderQueryParameters = {
  serialNumber?: string | null | undefined ;
  serviceProductId?: string | null | undefined ;
  userLanguage?: string | undefined ;
}

export type PatchRepairOrderDraftRepairsOrderQueryParameters = {
  id: number ;
}

export type DeleteRepairOrderDraftRepairsOrderQueryParameters = {
  id: number ;
}

export type GetSalesViewRepairsOrderQueryParameters = {
  repairsOrderId: string ;
}

export type PrintSalesRepairsOrderQueryParameters = {
  repairsOrderId: string ;
}

export type PrintRepairOrderRepairsOrderQueryParameters = {
  repairsOrderIds?: string[] | undefined ;
}

export type DownloadSalesPrintRepairsOrderQueryParameters = {
  repairsOrderId: string ;
  abasFileId: string ;
}

export type ApproveCostEstimateRepairsOrderQueryParameters = {
  repairsOrderId: string ;
}

export function getInvoiceAddressUrl(contactId?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/repairs-order/invoice-address?";
if (contactId === null)
    throw new Error("The parameter 'contactId' cannot be null.");
else if (contactId !== undefined)
    url_ += "contactId=" + encodeURIComponent("" + contactId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getInvoiceAddressDefaultOptions: Omit<UseQueryOptions<Types.InvoiceAddressDto, unknown, Types.InvoiceAddressDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.InvoiceAddressDto, unknown, Types.InvoiceAddressDto>, 'queryFn'>> = {
};
export function getGetInvoiceAddressDefaultOptions() {
  return getInvoiceAddressDefaultOptions;
};
export function setGetInvoiceAddressDefaultOptions(options: typeof getInvoiceAddressDefaultOptions) {
  getInvoiceAddressDefaultOptions = options;
}

export function getInvoiceAddressQueryKey(contactId?: string | undefined): QueryKey;
export function getInvoiceAddressQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { contactId,  } = params[0] as GetInvoiceAddressRepairsOrderQueryParameters;

    return trimArrayEnd([
        'RepairsOrderClient',
        'getInvoiceAddress',
        contactId as any,
      ]);
  } else {
    return trimArrayEnd([
        'RepairsOrderClient',
        'getInvoiceAddress',
        ...params
      ]);
  }
}
export function __getInvoiceAddress(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getInvoiceAddress(
      context.queryKey[2] as string | undefined,axiosConfig    );
}

export function useGetInvoiceAddressQuery<TSelectData = Types.InvoiceAddressDto, TError = unknown>(dto: GetInvoiceAddressRepairsOrderQueryParameters, options?: Omit<UseQueryOptions<Types.InvoiceAddressDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Returns invoice address for the specified contact ID.
 * @param contactId (optional) 
 */
export function useGetInvoiceAddressQuery<TSelectData = Types.InvoiceAddressDto, TError = unknown>(contactId?: string | undefined, options?: Omit<UseQueryOptions<Types.InvoiceAddressDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetInvoiceAddressQuery<TSelectData = Types.InvoiceAddressDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.InvoiceAddressDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let contactId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ contactId,  } = params[0] as GetInvoiceAddressRepairsOrderQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [contactId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.InvoiceAddressDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getInvoiceAddress(context, axiosConfig) : __getInvoiceAddress,
    queryKey: getInvoiceAddressQueryKey(contactId),
    ...getInvoiceAddressDefaultOptions as unknown as Omit<UseQueryOptions<Types.InvoiceAddressDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Returns invoice address for the specified contact ID.
 * @param contactId (optional) 
 */
export function setGetInvoiceAddressData(queryClient: QueryClient, updater: (data: Types.InvoiceAddressDto | undefined) => Types.InvoiceAddressDto, contactId?: string | undefined) {
  queryClient.setQueryData(getInvoiceAddressQueryKey(contactId),
    updater
  );
}

/**
 * Returns invoice address for the specified contact ID.
 * @param contactId (optional) 
 */
export function setGetInvoiceAddressDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.InvoiceAddressDto | undefined) => Types.InvoiceAddressDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getInternalRepairOrderInvoiceAddressUrl(): string {
  let url_ = getBaseUrl() + "/api/repairs-order/invoice-address/internal-order";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getInternalRepairOrderInvoiceAddressDefaultOptions: Omit<UseQueryOptions<Types.InvoiceAddressDto, unknown, Types.InvoiceAddressDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.InvoiceAddressDto, unknown, Types.InvoiceAddressDto>, 'queryFn'>> = {
};
export function getGetInternalRepairOrderInvoiceAddressDefaultOptions() {
  return getInternalRepairOrderInvoiceAddressDefaultOptions;
};
export function setGetInternalRepairOrderInvoiceAddressDefaultOptions(options: typeof getInternalRepairOrderInvoiceAddressDefaultOptions) {
  getInternalRepairOrderInvoiceAddressDefaultOptions = options;
}

export function getInternalRepairOrderInvoiceAddressQueryKey(): QueryKey;
export function getInternalRepairOrderInvoiceAddressQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'RepairsOrderClient',
      'getInternalRepairOrderInvoiceAddress',
    ]);
}
export function __getInternalRepairOrderInvoiceAddress(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getInternalRepairOrderInvoiceAddress(
axiosConfig    );
}

/**
 * Returns invoice address from user's current open internal repair order.
 */
export function useGetInternalRepairOrderInvoiceAddressQuery<TSelectData = Types.InvoiceAddressDto, TError = unknown>(options?: Omit<UseQueryOptions<Types.InvoiceAddressDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetInternalRepairOrderInvoiceAddressQuery<TSelectData = Types.InvoiceAddressDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.InvoiceAddressDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.InvoiceAddressDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getInternalRepairOrderInvoiceAddress(context, axiosConfig) : __getInternalRepairOrderInvoiceAddress,
    queryKey: getInternalRepairOrderInvoiceAddressQueryKey(),
    ...getInternalRepairOrderInvoiceAddressDefaultOptions as unknown as Omit<UseQueryOptions<Types.InvoiceAddressDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Returns invoice address from user's current open internal repair order.
 */
export function setGetInternalRepairOrderInvoiceAddressData(queryClient: QueryClient, updater: (data: Types.InvoiceAddressDto | undefined) => Types.InvoiceAddressDto, ) {
  queryClient.setQueryData(getInternalRepairOrderInvoiceAddressQueryKey(),
    updater
  );
}

/**
 * Returns invoice address from user's current open internal repair order.
 */
export function setGetInternalRepairOrderInvoiceAddressDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.InvoiceAddressDto | undefined) => Types.InvoiceAddressDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createRepairOrderDraftUrl(): string {
  let url_ = getBaseUrl() + "/api/repairs-order/drafts";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createRepairOrderDraftMutationKey(): MutationKey {
  return trimArrayEnd([
      'RepairsOrderClient',
      'createRepairOrderDraft',
    ]);
}

/**
 * Creates a new repair draft in user's current open internal order.
 */
export function useCreateRepairOrderDraftMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.CreateRepairOrderDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.CreateRepairOrderDto, TContext> {
  const key = createRepairOrderDraftMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateRepairOrderDto) => Client.createRepairOrderDraft(dto),
    mutationKey: key,
  });
}
  
export function getUserOpenRepairOrderDraftsUrl(): string {
  let url_ = getBaseUrl() + "/api/repairs-order/drafts";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getUserOpenRepairOrderDraftsDefaultOptions: Omit<UseQueryOptions<Types.RepairOrderDraftListDto, unknown, Types.RepairOrderDraftListDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.RepairOrderDraftListDto, unknown, Types.RepairOrderDraftListDto>, 'queryFn'>> = {
};
export function getGetUserOpenRepairOrderDraftsDefaultOptions() {
  return getUserOpenRepairOrderDraftsDefaultOptions;
};
export function setGetUserOpenRepairOrderDraftsDefaultOptions(options: typeof getUserOpenRepairOrderDraftsDefaultOptions) {
  getUserOpenRepairOrderDraftsDefaultOptions = options;
}

export function getUserOpenRepairOrderDraftsQueryKey(): QueryKey;
export function getUserOpenRepairOrderDraftsQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'RepairsOrderClient',
      'getUserOpenRepairOrderDrafts',
    ]);
}
export function __getUserOpenRepairOrderDrafts(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getUserOpenRepairOrderDrafts(
axiosConfig    );
}

/**
 * Returns user's open repair drafts grouped with shared internal incoming number.
 */
export function useGetUserOpenRepairOrderDraftsQuery<TSelectData = Types.RepairOrderDraftListDto, TError = unknown>(options?: Omit<UseQueryOptions<Types.RepairOrderDraftListDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetUserOpenRepairOrderDraftsQuery<TSelectData = Types.RepairOrderDraftListDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.RepairOrderDraftListDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.RepairOrderDraftListDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getUserOpenRepairOrderDrafts(context, axiosConfig) : __getUserOpenRepairOrderDrafts,
    queryKey: getUserOpenRepairOrderDraftsQueryKey(),
    ...getUserOpenRepairOrderDraftsDefaultOptions as unknown as Omit<UseQueryOptions<Types.RepairOrderDraftListDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Returns user's open repair drafts grouped with shared internal incoming number.
 */
export function setGetUserOpenRepairOrderDraftsData(queryClient: QueryClient, updater: (data: Types.RepairOrderDraftListDto | undefined) => Types.RepairOrderDraftListDto, ) {
  queryClient.setQueryData(getUserOpenRepairOrderDraftsQueryKey(),
    updater
  );
}

/**
 * Returns user's open repair drafts grouped with shared internal incoming number.
 */
export function setGetUserOpenRepairOrderDraftsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.RepairOrderDraftListDto | undefined) => Types.RepairOrderDraftListDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createInternalRepairOrderUrl(): string {
  let url_ = getBaseUrl() + "/api/repairs-order/internal-order";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createInternalRepairOrderMutationKey(): MutationKey {
  return trimArrayEnd([
      'RepairsOrderClient',
      'createInternalRepairOrder',
    ]);
}

/**
 * Creates a new open internal repair order for current user or updates the existing open one.
 */
export function useCreateInternalRepairOrderMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.CreateInternalRepairOrderDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.CreateInternalRepairOrderDto, TContext> {
  const key = createInternalRepairOrderMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateInternalRepairOrderDto) => Client.createInternalRepairOrder(dto),
    mutationKey: key,
  });
}
  
export function requestDeviceUrl(serialNumber?: string | null | undefined, serviceProductId?: string | null | undefined, userLanguage?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/repairs-order/request-device?";
if (serialNumber !== undefined && serialNumber !== null)
    url_ += "SerialNumber=" + encodeURIComponent("" + serialNumber) + "&";
if (serviceProductId !== undefined && serviceProductId !== null)
    url_ += "ServiceProductId=" + encodeURIComponent("" + serviceProductId) + "&";
if (userLanguage === null)
    throw new Error("The parameter 'userLanguage' cannot be null.");
else if (userLanguage !== undefined)
    url_ += "userLanguage=" + encodeURIComponent("" + userLanguage) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let requestDeviceDefaultOptions: Omit<UseQueryOptions<Types.RepairDeviceDto, unknown, Types.RepairDeviceDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.RepairDeviceDto, unknown, Types.RepairDeviceDto>, 'queryFn'>> = {
};
export function getRequestDeviceDefaultOptions() {
  return requestDeviceDefaultOptions;
};
export function setRequestDeviceDefaultOptions(options: typeof requestDeviceDefaultOptions) {
  requestDeviceDefaultOptions = options;
}

export function requestDeviceQueryKey(dto: RequestDeviceRepairsOrderQueryParameters): QueryKey;
export function requestDeviceQueryKey(serialNumber?: string | null | undefined, serviceProductId?: string | null | undefined, userLanguage?: string | undefined): QueryKey;
export function requestDeviceQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { serialNumber, serviceProductId, userLanguage,  } = params[0] as RequestDeviceRepairsOrderQueryParameters;

    return trimArrayEnd([
        'RepairsOrderClient',
        'requestDevice',
        serialNumber as any,
        serviceProductId as any,
        userLanguage as any,
      ]);
  } else {
    return trimArrayEnd([
        'RepairsOrderClient',
        'requestDevice',
        ...params
      ]);
  }
}
export function __requestDevice(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.requestDevice(
      context.queryKey[2] as string | null | undefined,       context.queryKey[3] as string | null | undefined,       context.queryKey[4] as string | undefined,axiosConfig    );
}

export function useRequestDeviceQuery<TSelectData = Types.RepairDeviceDto, TError = unknown>(dto: RequestDeviceRepairsOrderQueryParameters, options?: Omit<UseQueryOptions<Types.RepairDeviceDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Requests device data by serial number or service product.
 * @param serialNumber (optional) Selected serial number (seriennummer)
 * @param serviceProductId (optional) Device id (serviceprodukt). This is needed to find certain device when the serial number belongs to several devices.
 * @param userLanguage (optional) 
 */
export function useRequestDeviceQuery<TSelectData = Types.RepairDeviceDto, TError = unknown>(serialNumber?: string | null | undefined, serviceProductId?: string | null | undefined, userLanguage?: string | undefined, options?: Omit<UseQueryOptions<Types.RepairDeviceDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useRequestDeviceQuery<TSelectData = Types.RepairDeviceDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.RepairDeviceDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let serialNumber: any = undefined;
  let serviceProductId: any = undefined;
  let userLanguage: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ serialNumber, serviceProductId, userLanguage,  } = params[0] as RequestDeviceRepairsOrderQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [serialNumber, serviceProductId, userLanguage, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.RepairDeviceDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __requestDevice(context, axiosConfig) : __requestDevice,
    queryKey: requestDeviceQueryKey(serialNumber, serviceProductId, userLanguage),
    ...requestDeviceDefaultOptions as unknown as Omit<UseQueryOptions<Types.RepairDeviceDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Requests device data by serial number or service product.
 * @param serialNumber (optional) Selected serial number (seriennummer)
 * @param serviceProductId (optional) Device id (serviceprodukt). This is needed to find certain device when the serial number belongs to several devices.
 * @param userLanguage (optional) 
 */
export function setRequestDeviceData(queryClient: QueryClient, updater: (data: Types.RepairDeviceDto | undefined) => Types.RepairDeviceDto, serialNumber?: string | null | undefined, serviceProductId?: string | null | undefined, userLanguage?: string | undefined) {
  queryClient.setQueryData(requestDeviceQueryKey(serialNumber, serviceProductId, userLanguage),
    updater
  );
}

/**
 * Requests device data by serial number or service product.
 * @param serialNumber (optional) Selected serial number (seriennummer)
 * @param serviceProductId (optional) Device id (serviceprodukt). This is needed to find certain device when the serial number belongs to several devices.
 * @param userLanguage (optional) 
 */
export function setRequestDeviceDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.RepairDeviceDto | undefined) => Types.RepairDeviceDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchRepairOrderDraftUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/repairs-order/drafts/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchRepairOrderDraftMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'RepairsOrderClient',
      'patchRepairOrderDraft',
      id as any,
    ]);
}

/**
 * Applies patch to a repair draft owned by current user.
 */
export function usePatchRepairOrderDraftMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, Types.PatchRepairOrderDraftDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.PatchRepairOrderDraftDto, TContext> {
  const key = patchRepairOrderDraftMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PatchRepairOrderDraftDto) => Client.patchRepairOrderDraft(id, dto),
    mutationKey: key,
  });
}
  
type PatchRepairOrderDraft__MutationParameters = PatchRepairOrderDraftRepairsOrderQueryParameters & {
  dto: Types.PatchRepairOrderDraftDto;
}

/**
 * Applies patch to a repair draft owned by current user.
 */
export function usePatchRepairOrderDraftMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, PatchRepairOrderDraft__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchRepairOrderDraftRepairsOrderQueryParameters}): UseMutationResult<void, unknown, PatchRepairOrderDraft__MutationParameters, TContext> {
  const key = patchRepairOrderDraftMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PatchRepairOrderDraft__MutationParameters) => Client.patchRepairOrderDraft(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function deleteRepairOrderDraftUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/repairs-order/drafts/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deleteRepairOrderDraftMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'RepairsOrderClient',
      'deleteRepairOrderDraft',
      id as any,
    ]);
}

/**
 * Deletes an open repair draft owned by current user.
 */
export function useDeleteRepairOrderDraftMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deleteRepairOrderDraftMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.deleteRepairOrderDraft(id),
    mutationKey: key,
  });
}
  
type DeleteRepairOrderDraft__MutationParameters = DeleteRepairOrderDraftRepairsOrderQueryParameters

/**
 * Deletes an open repair draft owned by current user.
 */
export function useDeleteRepairOrderDraftMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, DeleteRepairOrderDraft__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: DeleteRepairOrderDraftRepairsOrderQueryParameters}): UseMutationResult<void, unknown, DeleteRepairOrderDraft__MutationParameters, TContext> {
  const key = deleteRepairOrderDraftMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: DeleteRepairOrderDraft__MutationParameters) => Client.deleteRepairOrderDraft(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function submitRepairOrderUrl(): string {
  let url_ = getBaseUrl() + "/api/repairs-order/submit";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function submitRepairOrderMutationKey(): MutationKey {
  return trimArrayEnd([
      'RepairsOrderClient',
      'submitRepairOrder',
    ]);
}

/**
 * Submits all user's open repair drafts to Abas.
 */
export function useSubmitRepairOrderMutation<TContext>(options?: Omit<UseMutationOptions<Types.SubmitRepairOrderResponseDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.SubmitRepairOrderResponseDto, unknown, void, TContext> {
  const key = submitRepairOrderMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.submitRepairOrder(),
    mutationKey: key,
  });
}
  
export function getSalesViewUrl(repairsOrderId: string): string {
  let url_ = getBaseUrl() + "/api/repairs-order/cost-estimate/{repairsOrderId}/view";
if (repairsOrderId === undefined || repairsOrderId === null)
  throw new Error("The parameter 'repairsOrderId' must be defined.");
url_ = url_.replace("{repairsOrderId}", encodeURIComponent("" + repairsOrderId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getSalesViewDefaultOptions: Omit<UseQueryOptions<Types.SalesViewDto, unknown, Types.SalesViewDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.SalesViewDto, unknown, Types.SalesViewDto>, 'queryFn'>> = {
};
export function getGetSalesViewDefaultOptions() {
  return getSalesViewDefaultOptions;
};
export function setGetSalesViewDefaultOptions(options: typeof getSalesViewDefaultOptions) {
  getSalesViewDefaultOptions = options;
}

export function getSalesViewQueryKey(repairsOrderId: string): QueryKey;
export function getSalesViewQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { repairsOrderId,  } = params[0] as GetSalesViewRepairsOrderQueryParameters;

    return trimArrayEnd([
        'RepairsOrderClient',
        'getSalesView',
        repairsOrderId as any,
      ]);
  } else {
    return trimArrayEnd([
        'RepairsOrderClient',
        'getSalesView',
        ...params
      ]);
  }
}
export function __getSalesView(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getSalesView(
      context.queryKey[2] as string,axiosConfig    );
}

export function useGetSalesViewQuery<TSelectData = Types.SalesViewDto, TError = unknown>(dto: GetSalesViewRepairsOrderQueryParameters, options?: Omit<UseQueryOptions<Types.SalesViewDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Returns sales positions from Abas VIEW command for the specified repairs order ID.
 */
export function useGetSalesViewQuery<TSelectData = Types.SalesViewDto, TError = unknown>(repairsOrderId: string, options?: Omit<UseQueryOptions<Types.SalesViewDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetSalesViewQuery<TSelectData = Types.SalesViewDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.SalesViewDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let repairsOrderId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ repairsOrderId,  } = params[0] as GetSalesViewRepairsOrderQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [repairsOrderId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.SalesViewDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getSalesView(context, axiosConfig) : __getSalesView,
    queryKey: getSalesViewQueryKey(repairsOrderId),
    ...getSalesViewDefaultOptions as unknown as Omit<UseQueryOptions<Types.SalesViewDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Returns sales positions from Abas VIEW command for the specified repairs order ID.
 */
export function setGetSalesViewData(queryClient: QueryClient, updater: (data: Types.SalesViewDto | undefined) => Types.SalesViewDto, repairsOrderId: string) {
  queryClient.setQueryData(getSalesViewQueryKey(repairsOrderId),
    updater
  );
}

/**
 * Returns sales positions from Abas VIEW command for the specified repairs order ID.
 */
export function setGetSalesViewDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.SalesViewDto | undefined) => Types.SalesViewDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function printSalesUrl(repairsOrderId: string): string {
  let url_ = getBaseUrl() + "/api/repairs-order/cost-estimate/{repairsOrderId}/print";
if (repairsOrderId === undefined || repairsOrderId === null)
  throw new Error("The parameter 'repairsOrderId' must be defined.");
url_ = url_.replace("{repairsOrderId}", encodeURIComponent("" + repairsOrderId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let printSalesDefaultOptions: Omit<UseQueryOptions<Types.SalesPrintDto, unknown, Types.SalesPrintDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.SalesPrintDto, unknown, Types.SalesPrintDto>, 'queryFn'>> = {
};
export function getPrintSalesDefaultOptions() {
  return printSalesDefaultOptions;
};
export function setPrintSalesDefaultOptions(options: typeof printSalesDefaultOptions) {
  printSalesDefaultOptions = options;
}

export function printSalesQueryKey(repairsOrderId: string): QueryKey;
export function printSalesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { repairsOrderId,  } = params[0] as PrintSalesRepairsOrderQueryParameters;

    return trimArrayEnd([
        'RepairsOrderClient',
        'printSales',
        repairsOrderId as any,
      ]);
  } else {
    return trimArrayEnd([
        'RepairsOrderClient',
        'printSales',
        ...params
      ]);
  }
}
export function __printSales(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.printSales(
      context.queryKey[2] as string,axiosConfig    );
}

export function usePrintSalesQuery<TSelectData = Types.SalesPrintDto, TError = unknown>(dto: PrintSalesRepairsOrderQueryParameters, options?: Omit<UseQueryOptions<Types.SalesPrintDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Runs Abas print command for the sales document found by repairs order ID and returns generated document info.
 */
export function usePrintSalesQuery<TSelectData = Types.SalesPrintDto, TError = unknown>(repairsOrderId: string, options?: Omit<UseQueryOptions<Types.SalesPrintDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function usePrintSalesQuery<TSelectData = Types.SalesPrintDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.SalesPrintDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let repairsOrderId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ repairsOrderId,  } = params[0] as PrintSalesRepairsOrderQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [repairsOrderId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.SalesPrintDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __printSales(context, axiosConfig) : __printSales,
    queryKey: printSalesQueryKey(repairsOrderId),
    ...printSalesDefaultOptions as unknown as Omit<UseQueryOptions<Types.SalesPrintDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Runs Abas print command for the sales document found by repairs order ID and returns generated document info.
 */
export function setPrintSalesData(queryClient: QueryClient, updater: (data: Types.SalesPrintDto | undefined) => Types.SalesPrintDto, repairsOrderId: string) {
  queryClient.setQueryData(printSalesQueryKey(repairsOrderId),
    updater
  );
}

/**
 * Runs Abas print command for the sales document found by repairs order ID and returns generated document info.
 */
export function setPrintSalesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.SalesPrintDto | undefined) => Types.SalesPrintDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function printRepairOrderUrl(repairsOrderIds?: string[] | undefined): string {
  let url_ = getBaseUrl() + "/api/repairs-order/print?";
if (repairsOrderIds === null)
    throw new Error("The parameter 'repairsOrderIds' cannot be null.");
else if (repairsOrderIds !== undefined)
    repairsOrderIds && repairsOrderIds.forEach(item => { url_ += "repairsOrderIds=" + encodeURIComponent("" + item) + "&"; });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let printRepairOrderDefaultOptions: Omit<UseQueryOptions<Types.FileResponse, unknown, Types.FileResponse>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.FileResponse, unknown, Types.FileResponse>, 'queryFn'>> = {
};
export function getPrintRepairOrderDefaultOptions() {
  return printRepairOrderDefaultOptions;
};
export function setPrintRepairOrderDefaultOptions(options: typeof printRepairOrderDefaultOptions) {
  printRepairOrderDefaultOptions = options;
}

export function printRepairOrderQueryKey(repairsOrderIds?: string[] | undefined): QueryKey;
export function printRepairOrderQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { repairsOrderIds,  } = params[0] as PrintRepairOrderRepairsOrderQueryParameters;

    return trimArrayEnd([
        'RepairsOrderClient',
        'printRepairOrder',
        repairsOrderIds as any,
      ]);
  } else {
    return trimArrayEnd([
        'RepairsOrderClient',
        'printRepairOrder',
        ...params
      ]);
  }
}
export function __printRepairOrder(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.printRepairOrder(
      context.queryKey[2] as string[] | undefined,axiosConfig    );
}

export function usePrintRepairOrderQuery<TSelectData = Types.FileResponse, TError = unknown>(dto: PrintRepairOrderRepairsOrderQueryParameters, options?: Omit<UseQueryOptions<Types.FileResponse, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Generates and downloads a repair order PDF for the specified incoming number(s).
 * @param repairsOrderIds (optional) 
 */
export function usePrintRepairOrderQuery<TSelectData = Types.FileResponse, TError = unknown>(repairsOrderIds?: string[] | undefined, options?: Omit<UseQueryOptions<Types.FileResponse, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function usePrintRepairOrderQuery<TSelectData = Types.FileResponse, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.FileResponse, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let repairsOrderIds: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ repairsOrderIds,  } = params[0] as PrintRepairOrderRepairsOrderQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [repairsOrderIds, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.FileResponse, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __printRepairOrder(context, axiosConfig) : __printRepairOrder,
    queryKey: printRepairOrderQueryKey(repairsOrderIds),
    ...printRepairOrderDefaultOptions as unknown as Omit<UseQueryOptions<Types.FileResponse, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Generates and downloads a repair order PDF for the specified incoming number(s).
 * @param repairsOrderIds (optional) 
 */
export function setPrintRepairOrderData(queryClient: QueryClient, updater: (data: Types.FileResponse | undefined) => Types.FileResponse, repairsOrderIds?: string[] | undefined) {
  queryClient.setQueryData(printRepairOrderQueryKey(repairsOrderIds),
    updater
  );
}

/**
 * Generates and downloads a repair order PDF for the specified incoming number(s).
 * @param repairsOrderIds (optional) 
 */
export function setPrintRepairOrderDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.FileResponse | undefined) => Types.FileResponse) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function downloadSalesPrintUrl(repairsOrderId: string, abasFileId: string): string {
  let url_ = getBaseUrl() + "/api/repairs-order/cost-estimate/{repairsOrderId}/print/{abasFileId}";
if (repairsOrderId === undefined || repairsOrderId === null)
  throw new Error("The parameter 'repairsOrderId' must be defined.");
url_ = url_.replace("{repairsOrderId}", encodeURIComponent("" + repairsOrderId));
if (abasFileId === undefined || abasFileId === null)
  throw new Error("The parameter 'abasFileId' must be defined.");
url_ = url_.replace("{abasFileId}", encodeURIComponent("" + abasFileId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let downloadSalesPrintDefaultOptions: Omit<UseQueryOptions<Types.FileResponse, unknown, Types.FileResponse>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.FileResponse, unknown, Types.FileResponse>, 'queryFn'>> = {
};
export function getDownloadSalesPrintDefaultOptions() {
  return downloadSalesPrintDefaultOptions;
};
export function setDownloadSalesPrintDefaultOptions(options: typeof downloadSalesPrintDefaultOptions) {
  downloadSalesPrintDefaultOptions = options;
}

export function downloadSalesPrintQueryKey(dto: DownloadSalesPrintRepairsOrderQueryParameters): QueryKey;
export function downloadSalesPrintQueryKey(repairsOrderId: string, abasFileId: string): QueryKey;
export function downloadSalesPrintQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { repairsOrderId, abasFileId,  } = params[0] as DownloadSalesPrintRepairsOrderQueryParameters;

    return trimArrayEnd([
        'RepairsOrderClient',
        'downloadSalesPrint',
        repairsOrderId as any,
        abasFileId as any,
      ]);
  } else {
    return trimArrayEnd([
        'RepairsOrderClient',
        'downloadSalesPrint',
        ...params
      ]);
  }
}
export function __downloadSalesPrint(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.downloadSalesPrint(
      context.queryKey[2] as string,       context.queryKey[3] as string,axiosConfig    );
}

export function useDownloadSalesPrintQuery<TSelectData = Types.FileResponse, TError = unknown>(dto: DownloadSalesPrintRepairsOrderQueryParameters, options?: Omit<UseQueryOptions<Types.FileResponse, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Downloads a cost-estimate document from Abas through the current application.
 */
export function useDownloadSalesPrintQuery<TSelectData = Types.FileResponse, TError = unknown>(repairsOrderId: string, abasFileId: string, options?: Omit<UseQueryOptions<Types.FileResponse, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useDownloadSalesPrintQuery<TSelectData = Types.FileResponse, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.FileResponse, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let repairsOrderId: any = undefined;
  let abasFileId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ repairsOrderId, abasFileId,  } = params[0] as DownloadSalesPrintRepairsOrderQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [repairsOrderId, abasFileId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.FileResponse, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __downloadSalesPrint(context, axiosConfig) : __downloadSalesPrint,
    queryKey: downloadSalesPrintQueryKey(repairsOrderId, abasFileId),
    ...downloadSalesPrintDefaultOptions as unknown as Omit<UseQueryOptions<Types.FileResponse, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Downloads a cost-estimate document from Abas through the current application.
 */
export function setDownloadSalesPrintData(queryClient: QueryClient, updater: (data: Types.FileResponse | undefined) => Types.FileResponse, repairsOrderId: string, abasFileId: string) {
  queryClient.setQueryData(downloadSalesPrintQueryKey(repairsOrderId, abasFileId),
    updater
  );
}

/**
 * Downloads a cost-estimate document from Abas through the current application.
 */
export function setDownloadSalesPrintDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.FileResponse | undefined) => Types.FileResponse) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function approveCostEstimateUrl(repairsOrderId: string): string {
  let url_ = getBaseUrl() + "/api/repairs-order/cost-estimate/{repairsOrderId}/approve";
if (repairsOrderId === undefined || repairsOrderId === null)
  throw new Error("The parameter 'repairsOrderId' must be defined.");
url_ = url_.replace("{repairsOrderId}", encodeURIComponent("" + repairsOrderId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function approveCostEstimateMutationKey(repairsOrderId: string): MutationKey {
  return trimArrayEnd([
      'RepairsOrderClient',
      'approveCostEstimate',
      repairsOrderId as any,
    ]);
}

/**
 * Approves cost estimate for the specified repairs order ID.
 */
export function useApproveCostEstimateMutation<TContext>(repairsOrderId: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = approveCostEstimateMutationKey(repairsOrderId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.approveCostEstimate(repairsOrderId),
    mutationKey: key,
  });
}
  
type ApproveCostEstimate__MutationParameters = ApproveCostEstimateRepairsOrderQueryParameters

/**
 * Approves cost estimate for the specified repairs order ID.
 */
export function useApproveCostEstimateMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, ApproveCostEstimate__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: ApproveCostEstimateRepairsOrderQueryParameters}): UseMutationResult<void, unknown, ApproveCostEstimate__MutationParameters, TContext> {
  const key = approveCostEstimateMutationKey(options?.parameters?.repairsOrderId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: ApproveCostEstimate__MutationParameters) => Client.approveCostEstimate(data.repairsOrderId ?? options?.parameters?.repairsOrderId!),
  mutationKey: key,
});
}